import { gql, TypedDocumentNode } from "@apollo/client";

import { QueryManagedUserArgs } from "types/generated";

import { UserViewBinding, UserViewDetails } from "./types";

export type GetUserData = {
  managedUser: UserViewDetails & {
    userRoleBindings: UserViewBinding[];
  };
};

export const GET_USER_WITH_ROLES: TypedDocumentNode<GetUserData, QueryManagedUserArgs> = gql`
  query GetUserWithRoles($id: ID!) {
    managedUser(id: $id) {
      id
      invitationEmail
      status
      username
      role
      latestGroups
      slackMemberID
      accessRules {
        space
        spaceAccessLevel
      }
      userRoleBindings {
        id
        space {
          id
          name
        }
        userID
        role {
          id
          name
          isSystem
          description
        }
      }
    }
  }
`;

export const UPDATE_MANAGED_USER = gql`
  mutation UpdateManagedUser($input: ManagedUserUpdateInput!) {
    managedUserUpdate(input: $input) {
      id
      status
    }
  }
`;
